/**
 * ZUNO — Prévia visual de categorias (não autoritativa)
 * ─────────────────────────────────────────────────────────────
 * O preço final é sempre recalculado pelo backend com rota confiável,
 * pricingVersion e proteção do motorista. A V1 não aplica descontos.
 * ─────────────────────────────────────────────────────────────
 */

const DESCONTO_VS_CONCORRENCIA = 0;

// ─── SURGE POR HORÁRIO ──────────────────────────────────────
const SURGE_SCHEDULE = [
  { horaInicio: 0,  horaFim: 5,  competitorSurge: 1.20, label: "Madrugada"  },
  { horaInicio: 6,  horaFim: 8,  competitorSurge: 1.40, label: "Pico manhã" },
  { horaInicio: 9,  horaFim: 11, competitorSurge: 1.00, label: "Normal"     },
  { horaInicio: 12, horaFim: 13, competitorSurge: 1.20, label: "Almoço"     },
  { horaInicio: 14, horaFim: 17, competitorSurge: 1.00, label: "Normal"     },
  { horaInicio: 18, horaFim: 20, competitorSurge: 1.50, label: "Pico noite" },
  { horaInicio: 21, horaFim: 23, competitorSurge: 1.20, label: "Noite"      },
];

function getSurgeFactor(hora = new Date().getHours()) {
  const faixa = SURGE_SCHEDULE.find(f => hora >= f.horaInicio && hora <= f.horaFim)
    || SURGE_SCHEDULE[2];
  const zunoSurge = 1;
  return {
    competitorSurge: faixa.competitorSurge,
    zunoSurge,
    label: faixa.label,
    isSurge: false,
  };
}

// ─── TABELAS POR CIDADE ──────────────────────────────────────
// Cada cidade tem: moto, movel (Go), comfort (Elite)
// Estes valores montam apenas a prévia da tela; não são enviados como tarifa.
const CIDADE_CONFIGS = {
  // ── Jaraguá do Sul, SC (cidade de lançamento) ────────────
  "Jaraguá do Sul": {
    moto: {
      name: "Zuno Moto", description: "Mototáxi • Rápido e econômico",
      baseFare: 1.75, perKm: 0.79, perMinute: 0.16, minimumFare: 5.00,
      concBasefare: 2.00, concPerKm: 0.90, concPerMinute: 0.18, concMinimum: 5.50,
      comissao: 0, etaMinutes: { min: 2, max: 8 },
    },
    movel: {
      name: "Zuno Go", description: "Carro • Rápido e acessível",
      baseFare: 1.75, perKm: 0.96, perMinute: 0.175, minimumFare: 5.50,
      concBasefare: 2.00, concPerKm: 1.10, concPerMinute: 0.20, concMinimum: 6.00,
      comissao: 0, etaMinutes: { min: 5, max: 12 },
    },
    comfort: {
      name: "Zuno Elite", description: "Carro premium • Mais espaço e conforto",
      baseFare: 3.06, perKm: 1.25, perMinute: 0.26, minimumFare: 8.75,
      concBasefare: 3.50, concPerKm: 1.43, concPerMinute: 0.30, concMinimum: 10.00,
      comissao: 0, etaMinutes: { min: 6, max: 15 },
    },
  },

  // ── São Paulo, SP ────────────────────────────────────────
  // Referência Uber SP (abr/2026): UberX ~R$2,50+R$1,90/km+R$0,40/min mín R$9
  "São Paulo": {
    moto: {
      name: "Zuno Moto", description: "Mototáxi • Rápido e econômico",
      baseFare: 1.75, perKm: 1.14, perMinute: 0.25, minimumFare: 6.13,
      concBasefare: 2.00, concPerKm: 1.30, concPerMinute: 0.28, concMinimum: 7.00,
      comissao: 0, etaMinutes: { min: 2, max: 8 },
    },
    movel: {
      name: "Zuno Go", description: "Carro • Rápido e acessível",
      baseFare: 2.19, perKm: 1.66, perMinute: 0.35, minimumFare: 7.88,
      concBasefare: 2.50, concPerKm: 1.90, concPerMinute: 0.40, concMinimum: 9.00,
      comissao: 0, etaMinutes: { min: 5, max: 15 },
    },
    comfort: {
      name: "Zuno Elite", description: "Carro premium • Mais espaço e conforto",
      baseFare: 3.50, perKm: 2.10, perMinute: 0.44, minimumFare: 12.25,
      concBasefare: 4.00, concPerKm: 2.40, concPerMinute: 0.50, concMinimum: 14.00,
      comissao: 0, etaMinutes: { min: 6, max: 18 },
    },
  },

  // ── Blumenau, SC ────────────────────────────────────────
  "Blumenau": {
    moto: {
      name: "Zuno Moto", description: "Mototáxi • Rápido e econômico",
      baseFare: 1.75, perKm: 0.83, perMinute: 0.17, minimumFare: 5.25,
      concBasefare: 2.00, concPerKm: 0.95, concPerMinute: 0.19, concMinimum: 6.00,
      comissao: 0, etaMinutes: { min: 2, max: 8 },
    },
    movel: {
      name: "Zuno Go", description: "Carro • Rápido e acessível",
      baseFare: 1.75, perKm: 1.00, perMinute: 0.19, minimumFare: 6.00,
      concBasefare: 2.00, concPerKm: 1.15, concPerMinute: 0.22, concMinimum: 6.50,
      comissao: 0, etaMinutes: { min: 5, max: 12 },
    },
    comfort: {
      name: "Zuno Elite", description: "Carro premium • Mais espaço e conforto",
      baseFare: 3.06, perKm: 1.31, perMinute: 0.28, minimumFare: 9.00,
      concBasefare: 3.50, concPerKm: 1.50, concPerMinute: 0.32, concMinimum: 10.50,
      comissao: 0, etaMinutes: { min: 6, max: 15 },
    },
  },
};

// Cidade padrão se não detectada
const CIDADE_PADRAO = "Jaraguá do Sul";

function getConfigCidade(cidade) {
  return CIDADE_CONFIGS[cidade] || CIDADE_CONFIGS[CIDADE_PADRAO];
}

// ─── CACHE ───────────────────────────────────────────────────
const _cache = new Map();
const CACHE_TTL_MS = 30_000;

function _cacheKey(params) {
  return `${params.category}|${params.distanceKm}|${params.durationMinutes}|${params.hora}|${params.cidade}`;
}

function _cacheGet(key) {
  const entry = _cache.get(key);
  if (!entry) return null;
  if (Date.now() - entry.ts > CACHE_TTL_MS) { _cache.delete(key); return null; }
  return entry.value;
}

function _cacheSet(key, value) {
  if (_cache.size > 50) _cache.clear();
  _cache.set(key, { value, ts: Date.now() });
}

// ─── CÁLCULO PRINCIPAL ───────────────────────────────────────
function calcZunoPrice({
  distanceKm,
  durationMinutes,
  category = "movel",
  hora = new Date().getHours(),
  cidade = CIDADE_PADRAO,
}) {
  const km  = Math.max(0, Number(distanceKm)     || 0);
  const min = Math.max(0, Number(durationMinutes) || 0);

  const key = _cacheKey({ category, distanceKm: km, durationMinutes: min, hora, cidade });
  const cached = _cacheGet(key);
  if (cached) return cached;

  const configs = getConfigCidade(cidade);
  const cfg   = configs[category] || configs.movel;
  const surge = getSurgeFactor(hora);

  const tarifaBruta = (cfg.baseFare + km * cfg.perKm + min * cfg.perMinute) * surge.zunoSurge;
  const finalPrice  = +Math.max(tarifaBruta, cfg.minimumFare).toFixed(2);

  const concBruta        = (cfg.concBasefare + km * cfg.concPerKm + min * cfg.concPerMinute) * surge.competitorSurge;
  const precoConcorrente = +Math.max(concBruta, cfg.concMinimum).toFixed(2);

  const economia    = +Math.max(0, precoConcorrente - finalPrice).toFixed(2);
  const economiaPct = precoConcorrente > 0 ? +((economia / precoConcorrente) * 100).toFixed(1) : 0;
  const driverEarns = +(finalPrice * (1 - cfg.comissao)).toFixed(2);

  const result = {
    category:        cfg.name,
    description:     cfg.description,
    finalPrice,
    fullPrice:       finalPrice,
    precoConcorrente,
    economia,
    economiaPct,
    driverEarns,
    surgeFactor:     surge.zunoSurge,
    competitorSurge: surge.competitorSurge,
    surgeLabel:      surge.label,
    isSurge:         surge.isSurge,
    distanceKm:      km,
    durationMinutes: min,
    etaMin:          cfg.etaMinutes.min,
    etaMax:          cfg.etaMinutes.max,
    cidadeDetectada: cidade,
    baseFare:        +(cfg.baseFare * surge.zunoSurge).toFixed(2),
    perKm:           +(cfg.perKm * surge.zunoSurge).toFixed(2),
    perMin:          +(cfg.perMinute * surge.zunoSurge).toFixed(2),
  };

  _cacheSet(key, result);
  return result;
}

// ─── RETORNA AS TRÊS OPÇÕES ──────────────────────────────────
function getZunoOptions(params) {
  return {
    moto:    calcZunoPrice({ ...params, category: "moto" }),
    movel:   calcZunoPrice({ ...params, category: "movel" }),
    comfort: calcZunoPrice({ ...params, category: "comfort" }),
  };
}

// ─── LISTA DE CIDADES SUPORTADAS ─────────────────────────────
function getCidadesSuportadas() {
  return Object.keys(CIDADE_CONFIGS);
}

// ─── UTILITÁRIOS ─────────────────────────────────────────────
function calcConcorrentePrice(zunoPrice) {
  return +(zunoPrice / (1 - DESCONTO_VS_CONCORRENCIA)).toFixed(2);
}

function clearZunoCache() {
  _cache.clear();
}

export {
  calcZunoPrice,
  getZunoOptions,
  calcConcorrentePrice,
  getSurgeFactor,
  getConfigCidade,
  getCidadesSuportadas,
  SURGE_SCHEDULE,
  CIDADE_CONFIGS,
  DESCONTO_VS_CONCORRENCIA,
  clearZunoCache,
};
